import { UseQueryResult } from "@tanstack/react-query";
import { useCallback } from "react";
import { CalendarTask } from "../components/CalendarTemplate/Calendar/Calendar";
import { useTranslation } from "../i18n/useTranslation";
import { getFieldLabel } from "../utils/getFieldLabel";
import { translateTask } from "./api/karl-farm/constants";
import { TaskElement } from "./api/karl-farm/useAllTasks";
import { Field } from "./api/karl-farm/useFields";
import { dateToScore, ScoresResponse } from "./api/karl-farm/useScores";

export const useTaskToCalendarTask = () => {
  const { t } = useTranslation();

  return useCallback(
    (
      task: TaskElement,
      fields: Field[] | null,
      scoresQueryResult?: UseQueryResult<ScoresResponse, unknown>
    ): CalendarTask => {
      const taskStartDate = new Date(0);
      taskStartDate.setUTCSeconds(task.time.start);
      const durationInMinutes = task.time.duration;
      const taskEndDate = new Date(taskStartDate);
      taskEndDate.setMinutes(taskEndDate.getMinutes() + durationInMinutes);

      const title =
        task.attributes.title || translateTask(t, task.attributes.task);

      const location = task.fields
        .map((taskField) => {
          const fieldId = taskField.id;
          const field = fields?.find((field) => field.id === fieldId);
          return field ? getFieldLabel(field) : fieldId;
        })
        .join(", ");

      const scores = scoresQueryResult?.data?.data;
      const date = new Date(task.time.start * 1000);
      const score = scores == null ? null : dateToScore(scores, date) || null;

      return {
        id: task.id,
        task: task.attributes.task,
        title,
        location,
        start: taskStartDate,
        end: taskEndDate,
        duration: task.time.duration,
        score,
        userIds: task.users.map((user) => user.id),
      };
    },
    [t]
  );
};
